<template>
  <div class="guidepage" :style="{ background: pageBg }">
    <img v-lazy="pagebanner" />
  </div>
</template>
<script>
import api from '../utils/api'
export default {
  data () {
    return {
      pagebanner: '',
      pageBg: ''
    }
  },
  created () {
    this.getPageJSON()
  },
  methods: {
    async getPageJSON () {
      const data = await api.getJsonVersion('home-page')
      const p1 = data['home-page-1']
      this.pagebanner = p1 && p1.data.length && p1.data[0].img
      this.pageBg = p1 && p1.data.length && p1.data[0].bgcolor
      this.goHome(p1 && p1.data.length && p1.data[0].ext_json)
    },
    goHome (time) {
      setTimeout(() => {
        this.$router.replace({ name: 'home' })
      }, (time - 0) * 1000)
    }
  }
}
</script>
<style lang='less' scoped>
.guidepage {
  min-height: 100vh;
}
</style>
